import IMask from 'imask'

import { COUNTRY } from 'constants/config'

export const setInitialValues = (values: {
  [key: string]: string | number | null | undefined
}) => {
  const result: { [key: string]: string | number | undefined } = {}
  for (const i in values) {
    const value = values[i]
    let newValue: string | number | undefined
    if (value === 0) newValue = 0
    else if (!value) newValue = undefined
    else newValue = value
    result[i] = newValue
  }
  return result
}

export const maskPhoneNumber = (str?: string | null) => {
  if (!str) return undefined

  const getMaskPatterns = (country: Country) => {
    switch (country) {
      case 'PH':
        return {
          mask: '#00 000 0000',
          definitions: { '#': /[9]/ }
        }
      case 'ID':
        return {
          mask: '#00 000 000 000',
          definitions: { '#': /[8]/ }
        }
    }
  }

  const masking = new IMask.MaskedPattern(
    getMaskPatterns(COUNTRY)
  )
  return masking.resolve(str)
}